export default "__VITE_ASSET__DXuZuG3W__"